// ヘルプメッセージ
import React from 'react';
import { convertLine } from '../Convert';
interface Props {
  help_msg?: string;
}

const HelpMessage: React.FC<Props> = ({ help_msg }) => {
  const replaceReturnCode = (msg?: string) => {
    if (msg === null || typeof msg === 'undefined') {
      return msg;
    }
    return <React.Fragment>{convertLine(msg)}</React.Fragment>;
  };
  return (
    <>
      {help_msg && (
        <div>
          <span className="help-msg">
            <strong className="paragraph">{replaceReturnCode(help_msg)}</strong>
          </span>
        </div>
      )}
    </>
  );
};

export default HelpMessage;
